import { render, staticRenderFns } from "./national.vue?vue&type=template&id=5a06f49b&scoped=true&"
import script from "./national.vue?vue&type=script&lang=js&"
export * from "./national.vue?vue&type=script&lang=js&"
import style0 from "./national.vue?vue&type=style&index=0&id=5a06f49b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06f49b",
  null
  
)

export default component.exports